import { render, staticRenderFns } from "./AssessmentReport.vue?vue&type=template&id=dfe4580a&scoped=true"
import script from "./AssessmentReport.vue?vue&type=script&lang=js"
export * from "./AssessmentReport.vue?vue&type=script&lang=js"
import style0 from "./AssessmentReport.vue?vue&type=style&index=0&id=dfe4580a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dfe4580a",
  null
  
)

export default component.exports